export enum ChatMessageTypeEnum {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
  DOCUMENT = 'document',
  STICKER = 'sticker',
  VOICE = 'voice',
  AUDIO = 'audio',
  CONTACT = 'contact',
  LOCATION = 'location',
  VOLUME = 'volume',
  URL_BUTTON = 'url_button',
  ACTION_BUTTON = 'action_button',
  QR_CODE = 'qr_code',
  COPYABLE_TEXT = 'copyable_text'
}